import { defineMessages } from 'react-intl';

export const messages: {
	recentSearchIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	removeRecentSearchIcon: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	removeRecentSearchSubheading: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	recentSearchIconLabel: {
		id: 'dynamic-cards-search-page.dropdown_recent_icon_label',
		defaultMessage: 'Recent',
		description:
			'Label text for recent search icon shown in recent searches search input where user can click to search for a recent search',
	},
	removeRecentSearchIcon: {
		id: 'dynamic-cards-search-page.search-result.remove-recent-search',
		defaultMessage: 'Remove recent search icon',
		description: 'The icon that removes a recent search result',
	},
	removeRecentSearchSubheading: {
		id: 'dynamic-cards-search-page.search-result.remove-recent-search-result-subheading',
		defaultMessage: 'Recent search',
		description:
			'Subheading label shown next to each entry in the recent searches dropdown to identify it as a recent search that can be dismissed.',
	},
});
